/**
 * ⭐⭐ **OS TIPOS DE ATO, como sugestão do campo — 21/09/2026.**
 *
 * > *"É o tipo do ATO, com a lista exatamente como veio, e escrita livre para o
 * > que faltar."* — decisão dele, §39.1 nº 4
 *
 * > *"Acrescentar já ... os atos que levam patrimônio à família (integralização
 * > em holding, doação com usufruto, mudança de regime de bens, partilha em
 * > cartório), lançados por quem lê."* — decisão dele, §40 nº 18
 *
 * ⚠️ **A LISTA DE 49 QUE ELE CITOU NUNCA CHEGOU AO REPOSITÓRIO.** Esta sai do
 * que o Hub **já sabe reconhecer** na matrícula (`lib/leitura-de-matricula.ts`)
 * mais os atos de família que ele nomeou — **nada aqui é inventado**. Chegando
 * a dele, substitui esta.
 *
 * ⛔ **É SUGESTÃO, e o campo continua de escrita livre.** Lista fechada
 * obrigaria a traduzir o que o registro diz, e o registro é a fonte — é a mesma
 * razão pela qual `tipoDoImovel` é texto livre.
 *
 * ⭐⭐ **E os nomes importam porque o Hub LÊ o que se escreve aqui.** Os sinais
 * de blindagem procuram *doação*, *integralização*, *partilha*, *usufruto* e
 * *dação* no texto do lançamento; escrever "doação c/ usufr." faria o padrão
 * passar despercebido. ⚠️ A regressão do lado da API confere que **cada ato
 * desta lista que fala de família é reconhecido** — se um nome mudar aqui e o
 * reconhecimento deixar de pegar, ela reprova.
 */

/**
 * ⭐ **Os que levam patrimônio à família** — os quatro que ele nomeou.
 *
 * ⚠️ **Vêm primeiro na lista**, porque são os que interessam a quem investiga
 * blindagem, e uma lista alfabética os esconderia no meio dos corriqueiros.
 *
 * ⛔ **Estar nesta lista NÃO diz que houve fraude.** É o tipo do ato, como o
 * registro o nomeia; quem aponta padrão é o painel de sinais, que apresenta
 * suspeita e nunca conclui.
 */
export const ATOS_DE_FAMILIA = [
  'Doação com reserva de usufruto',
  'Integralização de capital em holding',
  'Partilha em cartório',
  'Mudança de regime de bens',
] as const;

/** Os atos que a leitura de matrícula já reconhece, em ordem alfabética. */
export const ATOS_CORRIQUEIROS = [
  'Adjudicação',
  'Alienação fiduciária',
  'Arrematação',
  'Arresto',
  'Caução',
  'Cessão de crédito',
  'Cessão de direitos',
  'Compra e venda',
  'Consolidação da propriedade',
  'Dação em pagamento',
  'Doação',
  'Hipoteca',
  'Indisponibilidade',
  'Integralização de capital',
  'Partilha',
  'Penhora',
  'Permuta',
  'Promessa de compra e venda',
  'Servidão',
  'Usucapião',
  'Usufruto',
] as const;

/** A lista inteira, na ordem em que a sugestão a oferece. */
export const TIPOS_DE_ATO: readonly string[] = [...ATOS_DE_FAMILIA, ...ATOS_CORRIQUEIROS];
